import Tag from '@/components/ui/custom/dataDisplay/Tag';
import { VersioningStatusEnum } from '@/enums/VersioningStatus';
import handleButtonContent from '@/functions/handleCourseStatusIcon';

interface CourseStatusProps {
  status: VersioningStatusEnum;
  version: number;
}

function CourseStatus({ status, version }: CourseStatusProps) {
  const buttonContent = handleButtonContent(status, version, 'w-5 h-5');

  return (
    <Tag
      data-testid="courseStatus"
      className={{
        base: 'text-warning font-500 gap-2 bg-warning-content border-warning border rounded-md p-1',
      }}
      color="custom"
      text={buttonContent.text}
      icon={buttonContent.icon}
    />
  );
}

export default CourseStatus;
